
import StyleProvider from '@/StyleProvider.vue';
import TheApp from './TheApp.vue';
import Vue, { PropType } from 'vue';
import i18n from '@/i18n';
import isValidLanguageValidator from '@/validators/langLocaleValidator';
import { mapActions, mapState, PiniaVuePlugin } from 'pinia';
import { useStore as useLangStore } from '@/stores/lang';
import { useStore as useAuthStore } from '@/stores/auth';
import isValidProofApprovalContext from '@/validators/proofApprovalContextValidator';

Vue.use(PiniaVuePlugin);

import { pinia } from '@/pinia';
import { SelectedPrintPositionData } from './typings';
import { SupportedLangCodes } from '@/constants/languageCodes';
import customersAPI from '@/services/CustomersService';

export default Vue.extend({
  components: {
    StyleProvider,
    TheApp,
  },

  props: {
    languageCode: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'en',
      validator: isValidLanguageValidator,
    },
    masterProductSku: {
      type: String,
      required: true,
    },
    sapCustomerId: {
      type: String,
      required: true,
    },
    tok: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: false,
      default: '',
    },
    userFullName: {
      type: String,
      default: '',
    },
    context: {
      type: String as PropType<'Customer' | 'CustomerCare' | 'PrePress'>,
      required: true,
      validator: isValidProofApprovalContext,
    },
    orderNumber: {
      type: String,
      required: false,
      default: '',
    },
    orderLineId: {
      type: String,
      required: false,
      default: '',
    },
    selectedPrintPositionData: {
      type: Array as PropType<SelectedPrintPositionData[]>,
      required: false,
      default() {
        return [];
      },
    },
    instructions: {
      type: String,
      default: '',
    },
    sendMailToCustomerCare: {
      type: Boolean,
      default: false,
    },
    selectedMethod: {
      type: String,
      required: true,
    },
    numberOfColorsPerPrintPosition: {
      type: Array as PropType<{ positionId: string; numberOfColors: number }[]>,
      default() {
        return [];
      },
    },
    customerCompanyLogoUrl: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      instructionsData: this.instructions,
      selectedPrintPosition: this.selectedPrintPositionData,
      sendMailToCustomerCareData: this.sendMailToCustomerCare,
    };
  },

  computed: {
    ...mapState(useLangStore, ['languageInUse']),
    ...mapState(useAuthStore, ['isTokValid']),
  },
  watch: {
    async languageInUse() {
      if (process.env.VUE_APP_USE_LOCAL_TRANSLATIONS === 'false') {
        var translationsJson = await customersAPI.getTranslations(
          this.languageInUse
        );
        this.$i18n.setLocaleMessage(this.languageInUse, translationsJson.data);
      }
    },
    isTokValid(newValue) {
      if (!newValue) {
        this.$emit('token-invalid-or-expired');
      }
    },

    async tok(newValue) {
      if (newValue !== '') {
        this.setTok(this.tok);
        await this.setDefaultTranslations();
      }
    },

    instructions(newValue) {
      this.instructionsData = newValue;
    },

    selectedPrintPositionData(newValue) {
      if (newValue === undefined || newValue.length === 0) {
        this.$emit('selected-print-positions:empty');
        return;
      }
      this.selectedPrintPosition = newValue;
    },

    sendMailToCustomerCare(newValue) {
      this.sendMailToCustomerCareData = newValue;
    },
  },

  async mounted() {
    if (this.selectedPrintPositionData.length === 0) {
      this.$emit('selected-print-positions:empty');
    }
    this.setLanguageLocale(this.languageCode);
    this.setSapCustomerId(this.sapCustomerId);
    this.setTok(this.tok);
    await this.setDefaultTranslations();

    console.log(
      'Upload logo mounted - masterProductSku - ',
      this.masterProductSku
    );
  },

  methods: {
    ...mapActions(useLangStore, [
      'setLanguageLocale',
      'setDefaultTranslations',
    ]),
    ...mapActions(useAuthStore, ['setSapCustomerId', 'setTok']),
  },
  i18n,
  pinia,
});
